import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { BellIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';

interface NotificationsMenuProps {
    pendingCampaignId?: string | null;
}

export const NotificationsMenu: React.FC<NotificationsMenuProps> = ({ pendingCampaignId }) => {
    const hasNotifications = !!pendingCampaignId;

    return (
        <Menu as="div" className="relative ml-4 flex-shrink-0">
            <div>
                <Menu.Button className="relative flex rounded-full bg-white p-1 text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2">
                    <span className="sr-only">Ver notificações</span>
                    <BellIcon className="h-6 w-6" aria-hidden="true" />
                    {hasNotifications && (
                        <span className="absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white ring-2 ring-white">
                            1
                        </span>
                    )}
                </Menu.Button>
            </div>
            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className="absolute right-0 z-10 mt-2 w-80 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="px-4 py-2 border-b border-gray-100">
                        <h3 className="text-sm font-semibold text-gray-900">Notificações</h3>
                    </div>

                    {!hasNotifications ? (
                        <div className="px-4 py-6 text-center text-sm text-gray-500">
                            Nenhuma notificação nova.
                        </div>
                    ) : (
                        <>
                            {pendingCampaignId && (
                                <Menu.Item>
                                    {({ active }) => (
                                        <Link
                                            to={`/collaborators/evaluations/${pendingCampaignId}`}
                                            className={`block px-4 py-3 text-sm border-l-4 border-indigo-500 ${active ? 'bg-gray-50' : ''
                                                }`}
                                        >
                                            <p className="font-medium text-gray-900">Avaliação Pendente</p>
                                            <p className="text-gray-500 mt-1">Você tem uma autoavaliação aguardando resposta.</p>
                                        </Link>
                                    )}
                                </Menu.Item>
                            )}
                        </>
                    )}
                </Menu.Items>
            </Transition>
        </Menu>
    );
};
